import fetchClient from '@/lib/fetch'

export type DashboardChartType = {
  id: number
  title: string
  viz: string
  // What the figure means, shown under the chart title.
  description?: string | null
  // The key of the chart in models.json (sante_binomes, relance_en_attente...): the blocks laid out by the page itself.
  key?: string | null
  columns: string[]
  rows: Array<Record<string, string | number | boolean | null>>
  // The chart could not be read: shown as unavailable.
  error?: true
}

export type V1GetDashboardResponseType = {
  scope: 'PROGRAM' | 'MANAGED_GROUPS' | 'ALL_PROGRAMS'
  title: string
  // Charts left out because they cannot be narrowed to a manager's groups.
  hiddenCharts: number
  tabs: Array<{ title: string; charts: DashboardChartType[] }>
}

export async function V1GetDashboard(programId: string): Promise<V1GetDashboardResponseType> {
  return fetchClient(`/v1/data/dashboard?programId=${programId}`, {
    method: 'GET',
  })
}

export type V1GetDashboardOverviewResponseType = {
  programCount: number
  adminCount: number
  managerCount: number
  // null: a single program, or no overview for this platform yet: the page opens the program view.
  dashboard: V1GetDashboardResponseType | null
}

export async function V1GetDashboardOverview(): Promise<V1GetDashboardOverviewResponseType> {
  return fetchClient('/v1/data/dashboard/overview', {
    method: 'GET',
  })
}
